import React from 'react';

import { CustomerTable } from '@/sections/customerManagement/components/CustomerTable';

export const BugBountyDashboard: React.FC = () => {
  return (
    <CustomerTable
      customerFilter={{ includeTypes: ['BUG_BOUNTY'] }}
      addButtonLabel="Add Bug Bounty Program"
      defaultCustomerType="BUG_BOUNTY"
      emptyStateTitle="No bug bounty programs found"
    />
  );
};
